/* eslint-disable max-len */
/* eslint-disable import/no-extraneous-dependencies */
import { SvgIcon, colors } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import { noop } from 'lodash';
import * as React from 'react';

const ExpandIcon: React.FC<CustomSvgIcon> = ({
    id = '',
    className = '',
    iconColor = colors.common.white,
    onClick = noop
}) => (
    <SvgIcon
        className={className}
        id={id}
        onClick={onClick}
    >
        <svg
            fill={iconColor}
            viewBox='0 0 10 10'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M3.18182 0.909091V0H0V3.18182H0.909091V1.39091L3.18182 3.65L3.65 3.18182L1.39091 0.909091H3.18182ZM3.18182 6.35L0.909091 8.60909V6.81818H0V10H3.18182V9.09091H1.39091L3.65 6.81818L3.18182 6.35ZM9.09091 8.60909L6.81818 6.35L6.35 6.81818L8.60909 9.09091H6.81818V10H10V6.81818H9.09091V8.60909ZM6.81818 0V0.909091H8.60909L6.35 3.18182L6.81818 3.65L9.09091 1.39091V3.18182H10V0H6.81818Z'
                fill={iconColor}
            />
        </svg>
    </SvgIcon>
);

export default ExpandIcon;